import styled from 'styled-components'

import { BUY_COLOR, POINT_OUTER_SIZE, SELL_COLOR } from './constants'

const INNER_SIZE = 4

type TradePositionChartPointProps = {
  x: number
  y: number
  type: 'sell' | 'buy'
}

export const TradePositionChartPoint: React.FC<
  TradePositionChartPointProps
> = ({ x, y, type }) => {
  const fill = type === 'buy' ? BUY_COLOR : SELL_COLOR

  const outerRadius = POINT_OUTER_SIZE / 2

  return (
    <g data-origin-y={y}>
      <OuterCircle
        cx={x}
        cy={y + outerRadius}
        r={POINT_OUTER_SIZE / 2}
        fill={fill}
        fillOpacity="0.29"
      ></OuterCircle>
      <circle cx={x} cy={y + outerRadius} r={INNER_SIZE / 2} fill={fill} />
    </g>
  )
}

const OuterCircle = styled.circle``
